import { render } from "./CoachSelectionForm.vue?vue&type=template&id=c9c19ed2"
import script from "./CoachSelectionForm.vue?vue&type=script&lang=js"
export * from "./CoachSelectionForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/sparta-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__